import { useQuery } from '@tanstack/react-query';
import { slotQueries } from '../api/slot-queries';
import type { SlotId } from '../api/slot-api';
import type { SlotListFilter, SlotReservesFilter } from '../lib/filters';

/** One page of bonus slots + the total count. */
export function useSlots(filter: SlotListFilter) {
  return useQuery(slotQueries.list(filter));
}

/** One slot — fetched only while the edit dialog is open. */
export function useSlot(id: SlotId | undefined) {
  return useQuery(slotQueries.detail(id ?? '', id !== undefined));
}

/** The couriers that reserved a slot (mounted only while the dialog is open). */
export function useSlotReserves(filter: SlotReservesFilter) {
  return useQuery(slotQueries.reserves(filter));
}

/** Equipment options for the slot form. */
export function useSlotEquipments(enabled: boolean) {
  return useQuery(slotQueries.equipments(enabled));
}
